import {Stack} from "@mui/material";
import type {ProvenanceLink} from "../../../../../sdo/ProvenanceLink.ts";
import {SummaryPill, SummaryPillRow} from "../resolvers/editors/ResolverUtils.tsx";

interface ProvenanceViewProps {
    provenanceLink: ProvenanceLink;
}

const hasText = (s: string | undefined | null) => !!(s && s.trim().length > 0);

function ProvenanceView({provenanceLink}: ProvenanceViewProps) {
    return (
        <Stack direction="column" spacing={0.5} sx={{width: "100%", maxWidth: 760, mx: "auto", alignItems: "stretch"}}>
            <SummaryPillRow>
                <SummaryPill label="Source Type" value={provenanceLink.sourceType || "—"}/>
                <SummaryPill label="Source UID" value={provenanceLink.sourceUID || "—"}/>
            </SummaryPillRow>
            <SummaryPillRow>
                <SummaryPill label="Source URL" value={hasText(provenanceLink.sourcePath) ? provenanceLink.sourcePath : "—"}/>
            </SummaryPillRow>
            {hasText(provenanceLink.details) && (
                <SummaryPillRow>
                    <SummaryPill label="Details" value={provenanceLink.details}/>
                </SummaryPillRow>
            )}
        </Stack>
    );
}

export default ProvenanceView;
